export const getFirstLetters = (inputString: string) => {
  const [first, second] = inputString.trim().split(' ');
  if (second) {
    return `${first[0]}${second[0]}`;
  } else if (first) {
    return first.substring(0, 2);
  } else {
    return '';
  }
};

export const getUserDisplayName = (
  user:
    | {
        firstname?: string | null;
        lastname?: string | null;
        email: string;
        id: number;
      }
    | undefined,
  currentUserId: number
): string => {
  if (!user) {
    return 'Anonymous';
  }
  const { firstname, lastname, email, id } = user;
  if (id === -1) {
    return 'Anonymous';
  }
  if (firstname || lastname) {
    const preparedFirstName = firstname ?? '';
    const preparedLastName = lastname ?? '';
    return `${preparedFirstName} ${preparedLastName} ${id === currentUserId ? ' (You)' : ''}`;
  } else {
    return email;
  }
};
